<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Expense Record</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/expenses">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :docCreate="docCreate" :initial="dataItem"  @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
    categories: []
  }),
  methods: {
    save(data) {
      const url = "/expenditure";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
          self.$store.commit("btnLoader", false);
            self.$router.push("/expenses");
          } else {
          self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
        self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created () {
  },
};
</script>